export default {
    namespaced: true,
    state: () => ({
        recaptcha_token: '',
        locale: 'it',
        tokencampagna: '',
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        partner_code: '',
        partner: null,
        partner_code_readonly: false,
        ticketchiusokassociati: false,
        ticketid: null,
        stepcompletati : [],
        tktref:null,
        giropasseggeroaggiuntivo:0,
    }),
    getters:{
        getLocale:(state)=>{
            return state.locale;
        },
        getUtmSource:(state)=>{
            return state.utm_source;
        },
        getUtmMedium:(state)=>{
            return state.utm_medium;
        },
        getUtmCampaign:(state)=>{
            return state.utm_campaign;
        },
        getPartnerCode:(state)=>{
            return state.partner_code;
        },
        getPartner:(state)=>{
            return state.partner;
        },
        getPartnerCodeReadOnly:(state)=>{
            return state.partner_code_readonly;
        },
        getTicketChiusiOkAssociati:(state)=>{
            return state.ticketchiusokassociati;
        },
        getTicketId:(state)=>{
            return state.ticketid;
        },
        getStepCompletati:(state)=>{
            return state.stepcompletati;
        },
        getTicketRef:(state)=>{
            return state.tktref;
        },
        getGiroPasseggeroAggiuntivo:(state)=>{
            return state.giropasseggeroaggiuntivo;
        }
    },
    actions: {
        commitSetRecaptchaToken: (context, token) => {
            context.commit('setRecaptchaToken', token);
        },
        commitSetLocale: (context,value)=>{
            context.commit('setLocale',value);
        },
        commitSetTokenCampagna: (context,token)=>{
            context.commit('setTokenCampagna',token);
        },
        commitSetUtmSource:(context,value)=>{
            context.commit('setUtmSource',value);
        },
        commitSetUtmMedium:(context,value)=>{
            context.commit('setUtmMedium',value);
        },
        commitSetUtmCampaign:(context,value)=>{
            context.commit('setUtmCampaign',value)
        },
        commitSetPartnerCode:(context,value)=>{
            context.commit('setPartnerCode',value);
        },
        commitSetPartner:(context,value)=>{
            context.commit('setPartner',value);
        },
        commitSetPartnerCodeReadOnly:(context,value)=>{
            context.commit('setPartnerCodeReadOnly',value)
        },
        commitTicketChiusiOkAssociati:(context,value)=>{
            context.commit('setTicketChiusiOkAssociati',value);
        },
        commitTicketId:(context,value)=>{
            context.commit('setTicketId',value);
        },
        commitSetStepCompletato:(context, step)=>{
            context.commit('setStepCompletato',step);
        },
        commitPulisciStato:(context)=>{
            context.commit('pulisciStato');
        },
        commitSetTicketref:(context,value)=>{
            context.commit('setTicketRef',value);
        },
        commitSetGiroPasseggeroAggiuntivo:(context,value)=>{
            context.commit('setGiroPasseggeroAggiuntivo',value);
        }
    },
    mutations: {
        setRecaptchaToken: (state, token) => {
            state.recaptcha_token = token;
        },
        setLocale: (state,value)=>{
            state.locale = value;
        },
        setTokenCampagna: (state,token)=>{
            state.tokencampagna = token;
        },
        setUtmSource: (state,value)=>{
            state.utm_source = value;
        },
        setUtmMedium: (state,value)=>{
            state.utm_medium = value;
        },
        setUtmCampaign: (state,value)=>{
            state.utm_campaign = value;
        },
        setPartnerCode: (state,value)=>{
            state.partner_code = value;
        },
        setPartner:(state,value)=>{
            state.partner = value;
        },
        setPartnerCodeReadOnly:(state,value)=>{
            state.partner_code_readonly = value;
        },
        setTicketChiusiOkAssociati:(state,value)=>{
            state.ticketchiusokassociati = value;
        },
        setTicketId: (state,value)=>{
            state.ticketid = value;
        },
        setStepCompletato: (state,step)=>{
            state.stepcompletati.push(step);
        },
        setTicketRef: (state,value)=>{
          state.tktref = value;
        },
        setGiroPasseggeroAggiuntivo : (state,value)=>{
          state.giropasseggeroaggiuntivo = value;
        },
        pulisciStato:(state)=>{
            state.stepcompletati = [];
            state.ticketid = null;
            state.tktref = null;
            state.ticketchiusokassociati = false;
            state.giropasseggeroaggiuntivo = 0;
        }
    },
}